import React from "react";
import ReactSelect, {
  Props as ReactSelectProps,
  SingleValue,
  MultiValue,
  ActionMeta,
} from "react-select";
import classNames from "classnames";
import "./styles.scss";

export interface Option {
  value: string | number;
  label: string;
}

export interface SearchableSelectProps
  extends Omit<ReactSelectProps<Option>, "onChange" | "value"> {
  options: Option[];
  className?: string;
  name?: string;
  value?: string | number | Array<string | number>;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  "data-testid"?: string;
}

const SearchableSelect: React.FC<SearchableSelectProps> = ({
  className,
  options,
  onChange,
  name,
  value,
  isMulti,
  ...rest
}) => {
  const getSelected = () => {
    if (isMulti && Array.isArray(value)) {
      return options.filter(opt => value.includes(opt.value.toString()));
    } else {
      return (
        options.find(opt => opt.value.toString() === value?.toString()) ?? null
      );
    }
  };

  const handleChange = (
    newValue: SingleValue<Option> | MultiValue<Option>,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _actionMeta: ActionMeta<Option>
  ) => {
    if (onChange) {
      const syntheticEvent = {
        target: {
          name: name ?? "",
          value: isMulti
            ? (newValue as Option[]).map(opt => opt.value.toString())
            : (newValue as Option | null)?.value.toString() ?? "",
        },
      } as React.ChangeEvent<HTMLSelectElement>;

      onChange(syntheticEvent);
    }
  };

  return (
    <div
      className={classNames("tg_searchable-select", className)}
      data-testid={rest["data-testid"]}
    >
      <ReactSelect
        options={options}
        classNamePrefix="tg_searchable-select"
        name={name}
        isMulti={isMulti}
        onChange={handleChange}
        value={getSelected()}
        {...rest}
        placeholder=""
        noOptionsMessage={() => ""}
      />
    </div>
  );
};

export default SearchableSelect;
